import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  principiosActivos: [],
  principioActivo: {},
  error: "", // for error message
  loading: false,
  errorMsg: false, // for error
  colorMsg: "",
  exito: false,
};

const principiosActivosSlice = createSlice({
  name: "principiosActivos",
  initialState,
  reducers: {
    apiError(state, action) {
      state.error = action.payload;
      state.loading = false;
      state.errorMsg = true;
      state.colorMsg = "danger";
    },
    principiosActivosSuccess(state, action) {
      state.principiosActivos = action.payload.data;
      state.loading = false;
      state.errorMsg = false;
      state.error = action.payload.message;
      state.colorMsg = "success";
      state.exito = false;
    },
    principioActivoSuccess(state, action) {
      state.principioActivo = action.payload.data;
      state.loading = false;
      state.errorMsg = true;
      state.colorMsg = "success";
      state.error = action.payload.message;
      state.exito = true;
    },
    principiosActivosDeleteSuccess(state, action) {
      state.error = action.payload.message;
      state.loading = true;
      state.errorMsg = true;
      state.error = action.payload.message;
      state.colorMsg = "success";
      state.exito = false;
    },
    reset_principiosActivos_flag(state) {
      state.success = false;
      state.error = "";
      state.loading = false;
      state.errorMsg = false;
      state.colorMsg = "";
    },
  },
});

export const {
  apiError,
  principiosActivosSuccess,
  principioActivoSuccess,
  principiosActivosDeleteSuccess,
  reset_principiosActivos_flag,
} = principiosActivosSlice.actions;

export default principiosActivosSlice.reducer;
